import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { HubLogoModule } from '../../hub-logo/hub-logo.module';
import { RouterModule } from '@angular/router';
import { TrWrapperTwoColumnsModule } from '../../tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { PiNewPasswordEmailSuccessfullySent } from './pi-new-password-email-successfully-sent.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        HubLogoModule,
        TrWrapperTwoColumnsModule,
        RouterModule,
    ],
    exports: [ PiNewPasswordEmailSuccessfullySent ],
    declarations: [ PiNewPasswordEmailSuccessfullySent ],
    entryComponents: [ PiNewPasswordEmailSuccessfullySent ],
})
export class PiNewPasswordEmailSuccessfullySentModule {}
